import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

// When the request succeeds
const success = response => response.data;

// When the request fails
const failed = () => {};

export default wordboard => Vue.$http
    .patch(`Wordboards/${encodePathSegment(wordboard.id)}`, wordboard)
    .then(success)
    .catch(failed);



// WEBPACK FOOTER //
// ./src/services/wordboard/edit.js